var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.mainClasses},_vm._l((_vm.categories),function(category,index){return _c('TheCategoriesItem',{key:category.guid,ref:"categories",refInFor:true,attrs:{"context":_vm.context,"category":category,"category-index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }